import Vue from 'vue'
import Router from 'vue-router'
import Analysis from '@/views/dashboard/Analysis'
import Home from '@/views/dashboard//Home'
import AquaticSpecial from '@/views/aquaticspecial/AquaticSpecial'
import AquaticSpecialDetial from '@/views/aquaticspecial/AquaticSpecialDetial'
import AquaticState from '@/views/aquaticstate/AquaticState'
import AquaticStateDetial from '@/views/aquaticstate/AquaticStateDetial'
import AquaticExperts from '@/views/aquaticexperts/AquaticExperts'
import AquaticExpertsDetial from '@/views/aquaticexperts/AquaticExpertsDetial'
import AquaticCommission from '@/views/aquaticcommission/AquaticCommission'
import AquaticTrain from '@/views/aquatictrain/AquaticTrain'
import AquaticTrainDetial from '../views/aquatictrain/AquaticTrainDetial'
import AquaticZxfw from '@/views/aquaticzixun/AquaticZxfw'
import AquaticStandards from '@/views/aquaticstandards/AquaticStandards'


Vue.use(Router)

export default new Router({
  //base: './',
  routes: [
    {
      path: '/',
      name: 'Analysis',
      component: Analysis,
      redirect:'home',
      children:[
        {
          path:'home',
          name:'Home',
          component:Home
        },
        // 水产专题
        {
          path:'aquaticspecial',
          name:'aquaticspecial',
          component:AquaticSpecial
        },
        // 水产专题详情
        {
          path:'aquaticdetial',
          name:'aquaticdetial',
          component:AquaticSpecialDetial
        },
        // 标准动态
        {
          path:'aquaticstate',
          name:'aquaticstate',
          component:AquaticState
        },
        // 标准动态详情
        {
          path:'statedetial',
          name:'statedetial',
          component:AquaticStateDetial
        },
        // 专家库
        {
          path:'aquaticexperts',
          name:'aquaticexperts',
          component:AquaticExperts
        },
        // 专家库详情
        {
          path:'aquaticexpertsdetial',
          name:'aquaticexpertsdetial',
          component:AquaticExpertsDetial
        },
        // 水产委会
        {
          path:'aquaticcommission',
          name:'aquaticcommission',
          component:AquaticCommission
        },
        // 培训宣贯
        {
          path:'aquatictrain',
          name:'aquatictrain',
          component:AquaticTrain
        },
        // 培训宣贯详情
        {
          path:'aquatictraindetial',
          name:'aquatictraindetial',
          component:AquaticTrainDetial
        },
        // 咨询服务
        {
          path:'aquaticzxfw',
          name:'aquaticzxfw',
          component:AquaticZxfw
        },
        // 水产标准
        {
          path:'aquaticstandards',
          name:'aquaticstandards',
          component:AquaticStandards
        }
      ]
    },

  ],
  mode:'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js